import gql from 'graphql-tag'

export default gql`
	mutation addLoyaltyCardGroup($fields: LoyaltyCardGroupCharacter!) {
		cashAssist {
			addLoyaltyCardGroup(fields: $fields) {
				id
				name
			}
		}
	}
`
